import React from "react";
import "./Cart.css";
import iconCart from "../assets/images/icon-cart.svg";

const MEAL_PRICE = 14.95;
const DISCOUNT = 20;
const TOTAL_SLOTS = 6;

function formatPrice(amount) {
  return amount.toFixed(2).replace(".", ",") + " $";
}

export default function Cart({ mealsCount = 0, onConfirm, onClick }) {
  if (mealsCount === 0) return null;

  const original = mealsCount * MEAL_PRICE;
  const final = Math.max(0, original - DISCOUNT);
  const isComplete = mealsCount >= TOTAL_SLOTS;

  return (
    <div className="cart">
      <div className="cart__confirm">
        <div className="cart__prices">
          <p className="cart__price-original">{formatPrice(original)}</p>
          <p className="cart__price-final">{formatPrice(final)}</p>
        </div>
        <button
          className={`cart__button${isComplete ? " cart__button--active" : ""}`}
          onClick={onConfirm}
          disabled={!isComplete}
        >
          Confirmer
        </button>
      </div>

      <div
        className="cart__icon-wrapper"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <div className="cart__icon">
          <img src={iconCart} alt="Panier" />
        </div>
        {!isComplete && (
          <div className="cart__badge">
            {mealsCount} / {TOTAL_SLOTS}
          </div>
        )}
      </div>
    </div>
  );
}
